import React from 'react';
import { withStyles } from '@material-ui/core';
import Statcard from '~/app/Components/Dashboard/OverviewV2/primitives/Statcard';
import SectionHeader from '~/app/Components/Dashboard/OverviewV2/primitives/SectionHeader';
import { useHistory } from 'react-router-dom';
import { actions as appActions } from '~/app/redux/modules/app';
import {
  BUSINESS_RETURN_TAB,
  INDIVIDUAL_RETURN_TAB,
  TAX_RETURN_LIST_FILTERS,
  TITLE_TAB_NAMES,
} from '~/app/constants.js';
import { useDispatch, useSelector } from 'react-redux';
import AuthAPI from '~/app/api/authAPI.js';
import ErrorHelpers from '~/app/errorHelpers.js';
import WebHelpers from '~/app/webHelpers.js';
import { actions as returnListActions } from '~/app/redux/returnList/duck';

const styles = theme => ({
  section: { ...theme.grid.section },
  grid: {
    ...theme.grid.grid,
  },
});

const SectionGrid = ({ classes, title, cards, headerContent, panelId, labelledBy }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { officeProfile } = useSelector(state => ({
    officeProfile: state.officeProfile,
  }));

  const setBusinessMode = async isBusiness => {
    try {
      const changed = await AuthAPI.toggleBusinessMode(officeProfile.is_feeder_office);
      if (!changed) throw new Error('Unable to change return type');
      dispatch(
        returnListActions.setColumnList(isBusiness ? BUSINESS_RETURN_TAB : INDIVIDUAL_RETURN_TAB),
      );
    } catch (error) {
      ErrorHelpers.handleError('Error toggling business mode', error);
      throw error;
    }
  };

  const handleClick = async card => {
    if (!card.action) return;

    if (
      card.entity &&
      Boolean(WebHelpers.getJWTPayload()?.is_business) !== (card.entity === 'Business')
    ) {
      try {
        await setBusinessMode(card.entity === 'Business');
      } catch (error) {
        return;
      }
    }

    if (card.action.filingType) {
      dispatch(
        appActions.selectTitleTabByNameFiltered(TITLE_TAB_NAMES.TAX_RETURNS, {
          name: `${card.action.filingLabel}: ${card.title}`,
          value: 'filingStatus',
          filterType: '0',
          filingType: card.action.filingType,
          filingStatusCode: card.action.filingStatusCode,
        }),
      );
    } else if (card.action.status) {
      dispatch(
        appActions.selectTitleTabByNameFiltered(TITLE_TAB_NAMES.TAX_RETURNS, {
          name: 'Status: ' + card.title,
          value: card.action.status,
          filterType: TAX_RETURN_LIST_FILTERS.STATUS.toString(),
        }),
      );
    } else {
      dispatch(appActions.clearTitleTabFilterByName(TITLE_TAB_NAMES.TAX_RETURNS));
    }
    history.push({ pathname: '/tax-returns' });
  };

  return (
    <div className={classes.section}>
      <SectionHeader title={title}>{headerContent}</SectionHeader>
      <div
        className={classes.grid}
        id={panelId}
        role={panelId ? 'tabpanel' : undefined}
        aria-labelledby={labelledBy}
      >
        {cards.map(card => (
          <Statcard
            card={card}
            variant={card.variant}
            onClick={
              card.action && !card.loading && !card.error ? () => handleClick(card) : undefined
            }
            key={card.key}
          />
        ))}
      </div>
    </div>
  );
};

export default withStyles(styles)(SectionGrid);
